import additionalInfo from '@/api/report/additional-info'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
	...baseState,
}

export const getters = {}

export const mutations = {
	...baseMutations,
}

export const actions = {
	fetch(context, attributes = {}) {
		const params = Object.assign(
			{
				page: context.state.pagination.page,
				perPage: context.state.pagination.perPage,
				filter: {
					search: context.state.search
				}
			},
			attributes
		)
		return additionalInfo.get({ params }).then(response => {
			context.commit('RECEIVE_RESOURCES', response)
			return Promise.resolve(response)
		})
	},

	additionalInfoExcel(context, data) {
		return additionalInfo.additionalInfoExcel(
			Object.assign(
				{
					date_from: context.state.date_from,
					date_to: context.state.date_to
				},
				data
			)
		)
	}
}
